// Spec 2026-07-24 v9 §I18n: shared i18n bootstrap.
//
// Covers auth (login/register), header/nav, home, my-bookings, account and
// booking details/edit shells. Remaining admin surfaces still read from
// `ar.json` for the base copy but new strings should always be added here.
// The `<html>` `dir` + `lang` attributes are re-synced on every language
// change so third-party libs (Sonner, Datepicker, etc.) pick the right locale.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ar from "./locales/ar.json";
import en from "./locales/en.json";

const savedLang =
  (typeof window !== "undefined" && window.localStorage.getItem("mz_lang")) ||
  "ar";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    lng: savedLang,
    fallbackLng: "ar",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "mz_lang",
      caches: ["localStorage"],
    },
  });

function _syncHtmlAttrs(lng) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("dir", lng === "en" ? "ltr" : "rtl");
  document.documentElement.setAttribute("lang", lng);
}

_syncHtmlAttrs(savedLang);
i18n.on("languageChanged", _syncHtmlAttrs);

export default i18n;
